import { ParamsFilterKey } from "Config/filterSearchParams";
import { ShadcnAutoCompleteFilters, ShadcnAutoCompleteSearch } from "Explore/Components";
import { getSuggestKeywords } from "Explore/Services/Common";
import { getSuggestSearchVenues } from "Explore/Services/Venue";
import useFilterAndPagination from "Hooks/useFilterAndPagination";
import styles from "./FiltersVenue.module.scss";
import { RotateCcw } from "lucide-react";

const FiltersVenue = ({
  filter: filterProps,
  updateFilter: updateFilterProps,
}) => {
  const { filter: _filter, updateSearchParams: _updateSearchParams, resetFilter } =
    useFilterAndPagination();
  const filter = filterProps || _filter;
  const updateFilter = updateFilterProps || _updateSearchParams;

  return (
    <div className="flex flex-col gap-8 p-6 bg-white rounded-lg shadow-sm border border-gray-100 h-fit xl:sticky xl:top-[90px] xl:max-h-[calc(100vh-100px)] xl:overflow-y-auto xl:mt-[96px] w-full xl:max-w-[300px]">
      <div className="flex items-center justify-between">
        <h3 className="text-sm font-semibold text-gray-900 uppercase tracking-wider">Filters</h3>
        <button
          onClick={resetFilter}
          className="text-xs text-gray-400 hover:text-gray-700 flex items-center gap-1.5 transition-colors"
        >
          <RotateCcw size={12} />
          Clear filters
        </button>
      </div>
      
      <div className="flex flex-col gap-3">
        <label className="text-[11px] font-bold text-gray-400 uppercase tracking-widest">
          Name
        </label>
        <ShadcnAutoCompleteSearch
          placeholder={"Search by venue name"}
          functionSearch={getSuggestSearchVenues}
          filters={filter}
          setFilters={updateFilter}
          entity={ParamsFilterKey.QUERY}
        />
      </div>
      
      <div className="flex flex-col gap-3">
        <label className="text-[11px] font-bold text-gray-400 uppercase tracking-widest">
          Research area
        </label>
        <ShadcnAutoCompleteFilters
          placeholder={"Search by research area"}
          functionSearch={getSuggestKeywords}
          filters={filter}
          setFilters={updateFilter}
          entity={ParamsFilterKey.KEYWORD_QUERY}
          getFirstItemOnEnter
        />
      </div>
    </div>
  );
};

export default FiltersVenue;
